@if (!isUserloggedIn()) {
  <div>
    <h2 class="welcome">Welcome to the Halliburton CEMLive Management WebApp!</h2>
    <br />
    <h3><strong>Please sign-in.</strong></h3>
  </div>
}
